import { browser } from '$app/environment';
import type { MarketIdentifiers } from '$lib/types/market';
import { writable, type Writable } from 'svelte/store';

export const favouriteMarkets: Writable<Array<MarketIdentifiers>> = writable(
	JSON.parse(browser ? localStorage.getItem('favouriteMarkets') || '[]' : '[]')
);
if (browser)
	favouriteMarkets.subscribe((value) => {
		localStorage.favouriteMarkets = JSON.stringify(value);
	});
